import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, change, formValueSelector } from 'redux-form/immutable';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';
import _ from 'lodash';
import { fromJS } from 'immutable';
import { TextField } from 'redux-form-material-ui';

import { showDialog, hideDialog, showWarning, isDialogOpen } from '../../actions/dialogs';
import {
  // fetchCustomers,
  setCustomer as setNewCustomer,
  addContact,
  fetchCustomer,
  addAddress,
} from '../../actions/customers';
import { saveCustomerRoutine } from '../../routines';
import validate from './validate';
import Customer from '../Customer';

import { toArray, sortStrings } from '../../utils/helper';
import { required, future } from '../../utils/formvalidation';
import { renderSelectField, renderDatePicker } from '../../utils/reduxforms';

import commonStyles from '../styles';
import styles from './styles';

const futureInclusive = future(true);

const isAfterOrEqualStart = (value, values) => {
  const result = moment(value).startOf('d').isSameOrAfter(moment(values.get('start')).startOf('d'));
  return result ? undefined : 'End date must be after start date';
};

class Page1 extends React.Component {
  static propTypes = {
    // fetchCustomers: PropTypes.func.isRequired,
    customer: PropTypes.object,
    customers: PropTypes.array.isRequired,

    saveCustomer: PropTypes.func.isRequired,
    setNewCustomer: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showWarning: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    addContact: PropTypes.func.isRequired,
    addAddress: PropTypes.func.isRequired,

    customerId: PropTypes.string,
    start: PropTypes.object,

    change: PropTypes.func.isRequired,
  };

  //TODO auth0 - review
  // static contextTypes = {
  //   router: React.PropTypes.object.isRequired,
  // };

  state = {
    contacts: this.addNewContact(),
    addresses: [],
  };

  handleSelectCustomer = (event, newCustomerId, prevCustomerId) => {
    console.log('handleSelectCustomer', newCustomerId);
    if (newCustomerId === '0') {
      this.props.setNewCustomer({});
      this.props.showDialog('customer');
    } else if (newCustomerId !== prevCustomerId) {
      const customer = this.props.customers.find((cust) => cust.id === newCustomerId);
      if (customer) {
        this.showCustomerDependentFields(customer);
      } else {
        console.log('new customer not present', newCustomerId);
      }
    }
  };

  showCustomerDependentFields = (customer) => {
    const contacts = customer.contacts ? this.addNewContact().concat(toArray(customer.contacts).sort((a, b) => sortStrings(a.name, b.name))) : this.addNewContact();
    const addresses = customer.addresses ? this.addNewAddress().concat(toArray(customer.addresses)) : this.addNewAddress();
    console.log('contacts', contacts);
    console.log('addresses', addresses);
    this.setState({
      contacts,
      addresses,
    });
  };

  handleNewCustomerAdded = (customer) => {
    console.log('onNewCustomerAdded', customer);
    this.props.hideDialog('customer');
    if (customer) {
      this.props.change('customerId', customer.id);
      this.showCustomerDependentFields(customer);
    } else {
      this.props.change('customerId', null);
    }
  };

  handleSelectPrimaryContact = (evt, primaryContactId) => {
    console.log('handleSelectPrimaryContact', primaryContactId);
    const { customerId } = this.props;

    if (primaryContactId === '0') {
      if (!customerId) {
        this.props.showWarning('Invalid Customer', 'Please select a customer');
        return null;
      }
      this.props.showDialog('contact', {
        onRequestClose: this.handleRequestCloseContact,
      });
    }
  };

  handleRequestCloseContact = (contact) => {
    console.log('handleRequestCloseContact', contact);
    if (contact) {
      const { contacts } = this.state;
      this.setState({
        contacts: contacts.concat([contact]).sort((a, b) => sortStrings(a.name, b.name)),
      }, () => {
        this.props.change('primaryContactId', contact.id);
        const customer = this.props.customers.find((c) => c.id === this.props.customerId);
        this.props.saveCustomer(fromJS(_.update(customer, ['contacts'], (ctcts = {}) => _.assign({}, ctcts, { [contact.id]: contact }))));
      });
    }
    this.props.hideDialog('contact');
  };

  handleSelectOrigin = (evt, addressId) => {
    console.log('handleSelectOrigin', addressId);
    const { customerId } = this.props;

    if (addressId === '0') {
      if (!customerId) {
        showWarning('Invalid Customer', 'Please select a customer');
        return null;
      }

      this.props.showDialog('address', {
        onRequestClose: (addr) => this.handleRequestCloseAddress('origin', addr),
      });
    }
  };

  handleSelectDestination = (evt, addressId) => {
    console.log('handleSelectDestination', addressId);
    const { customerId } = this.props;

    if (addressId === '0') {
      if (!customerId) {
        showWarning('Invalid Customer', 'Please select a customer');
        return null;
      }

      this.props.showDialog('address', {
        onRequestClose: (addr) => this.handleRequestCloseAddress('destination', addr),
      });
    }
  };

  handleRequestCloseAddress = (type, address) => {
    console.log('handleRequestCloseAddress', address);
    this.props.hideDialog('address');

    if (address) {
      const { addresses } = this.state;
      this.setState({
        addresses: addresses.concat([address]),
      }, () => {
        this.props.change(`${type}Id`, address.id);
        const customer = this.props.customers.find((c) => c.id === this.props.customerId);
        this.props.saveCustomer(fromJS(_.update(customer, ['addresses'], (addrs = {}) => _.assign({}, addrs, { [address.id]: address }))));
      });
    }
  };
  // handleStartDateChange = (event, start) => {
  //   if (this.state.end && !isValidDates(start, this.state.end)) {
  //     this.setState({ futureEndDateError: 'End Date must be After Start' });
  //     return null;
  //   }
  //   if (isFutureDate(start)) {
  //     this.setState({
  //       futureStartDateError: '',
  //       start,
  //     });
  //     return this.props.setStart(this.props.job, start);
  //   }
  //   this.setState({ futureStartDateError: 'Start date must be in the future' });
  // };
  //
  // handleEndDateChange = (event, end) => {
  //   if (this.state.start && !isValidDates(this.state.start, end)) {
  //     this.setState({ futureEndDateError: 'End Date must be After Start' });
  //     return null;
  //   }
  //   if (isFutureDate(end)) {
  //     this.setState({
  //       futureEndDateError: '',
  //       end,
  //     });
  //     return this.props.setEnd(this.props.job, end);
  //   }
  //   this.setState({ futureEndDateError: 'End date must be in the future' });
  // };

  addNewContact() {
    return [{
      id: '0',
      name: ' -- Add New Contact --',
    }];
  }

  addNewAddress() {
    return [{
      id: '0',
      line1: ' -- Add New Address --',
    }];
  }

  render() {
    const { handleSubmit } = this.props;

    return (<form onSubmit={handleSubmit}>
      <div style={styles.row}>
        <Field
          name="reference"
          component={TextField}
          floatingLabelText="Reference"
          floatingLabelFixed
          fullWidth
          style={commonStyles.input}
          onBlur={this.handleBlur}
        />

        <Field
          name="customerId"
          component={renderSelectField}
          style={commonStyles.input}
          floatingLabelText="Customer"
          floatingLabelFixed
          fullWidth
          validate={[required]}
          onBlur={this.handleBlur}
          onChange={this.handleSelectCustomer}
        >
          { this.props.customers.map((customer) => {
            return (<MenuItem key={customer.id} value={customer.id} primaryText={customer.name}/>);
          })}
        </Field>

        <Field
          name="primaryContactId"
          component={renderSelectField}
          style={commonStyles.input}
          floatingLabelText="Primary Contact"
          floatingLabelFixed
          fullWidth
          onChange={this.handleSelectPrimaryContact}
          disabled={!this.props.customerId}
        >
          { this.state.contacts.map((contact) => {
            return (<MenuItem key={contact.id} value={contact.id} primaryText={contact.name}/>);
          })}
        </Field>
      </div>

      <Field
        name="description"
        component={TextField}
        floatingLabelText="Description"
        floatingLabelFixed
        fullWidth
        style={commonStyles.input}
        multiLine
      />

      <div style={styles.row}>
        <Field
          name="originId"
          component={renderSelectField}
          style={commonStyles.input}
          floatingLabelText="Origin"
          floatingLabelFixed
          fullWidth
          onChange={this.handleSelectOrigin}
          validate={[required]}
        >
          { this.state.addresses.map((address) => {
            return (<MenuItem key={address.id} value={address.id} primaryText={address.line1}/>);
          })}
        </Field>

        <Field
          name="destinationId"
          component={renderSelectField}
          style={commonStyles.input}
          floatingLabelText="Destination"
          floatingLabelFixed
          fullWidth
          onChange={this.handleSelectDestination}
          validate={[required]}
        >
          { this.state.addresses.map((address) => {
            return (<MenuItem key={address.id} value={address.id} primaryText={address.line1}/>);
          })}
        </Field>
      </div>
      <div style={styles.row}>
        <Field
          name="start"
          floatingLabelText="Start"
          floatingLabelFixed
          style={commonStyles.input}
          component={renderDatePicker}
          validate={[required, futureInclusive]}
          autoOk
          fullWidth
        />

        <Field
          name="end"
          floatingLabelText="End"
          floatingLabelFixed
          style={commonStyles.input}
          component={renderDatePicker}
          validate={[required, futureInclusive, isAfterOrEqualStart]}
          autoOk
          fullWidth
        />
      </div>

      <Field
        name="notes"
        component={TextField}
        floatingLabelText="Notes"
        floatingLabelFixed
        fullWidth
        style={commonStyles.input}
        multiLine
      />

      { isDialogOpen(this.props.dialogs, 'customer') ?
        <Customer onRequestClose={this.handleNewCustomerAdded}/> : null }
    </form>);
  }
}

const form = reduxForm({
  form: 'wizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
  initialValues: fromJS({
    start: moment().startOf('d').add(1, 'd').toDate(),
    end: moment().startOf('d').add(1, 'd').toDate(),
    // profile: null,
    created: { at: new Date().toISOString() },
  }),
})(Page1);

function mapStateToProps(state) {
  const selector = formValueSelector('wizard');

  return {
    dialogs: state.get('dialogs').get('dialogs').toJS(),
    start: selector(state, 'start'),
    customerId: selector(state, 'customerId'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    saveCustomer: saveCustomerRoutine.trigger,
    setNewCustomer,
    addContact,
    fetchCustomer,
    addAddress,
    change,
    showWarning,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/CreateJobDialog/Page1.js